
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { NO_INFORMATION } from "@/data/placeholders";

  import capitalizeLabel from "@/helpers/cardInfoHelperFunctions/capitalizeLabel";

  @Component
  export default class CardBodyItem extends Vue {
    @Prop({ type: String, default: "" }) readonly label!: string;
    @Prop({ type: String, default: " " }) readonly delimiter!: string;
    @Prop({ type: String, default: "" }) readonly labelClass!: string;
    @Prop({ type: String, default: "" }) readonly labelDivClass!: string;
    @Prop({ type: String, default: "overflow-hidden" }) readonly contentContainerClass!: string;
    @Prop({ type: [String, Number], default: undefined }) readonly itemExtraInfo?: string | number;
    @Prop({ type: String, default: undefined }) readonly customAlign?: string;
    @Prop({ type: [String, Number], default: undefined }) readonly content?: string | number;
    @Prop({ type: Boolean, default: false }) readonly wide!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isFoldable!: boolean;
    @Prop({ type: String, default: "" }) readonly textStyleClasses!: string;
    @Prop({ type: Boolean, default: false }) readonly highlighted!: boolean;
    @Prop({ type: Boolean, default: false }) readonly highlightContent!: boolean;
    @Prop({ type: Boolean, default: false }) readonly alarm!: boolean;

    get generalClasses(): Record<string, boolean> {
      return {
        ["text-red-600"]: this.alarm,
        ["font-bold"]: this.highlighted,
      };
    }

    get formattedLabel(): string {
      return capitalizeLabel(this.label, this.delimiter);
    }

    get generalTextStyles(): Record<string, boolean> {
      return {
        [this.textStyleClasses]: Boolean(this.textStyleClasses),
        ["text-gray-600"]: !this.textStyleClasses,
      };
    }

    get width(): string {
      return this.wide ? "w-20" : "w-16";
    }

    get textClasses(): Record<string, boolean> {
      return {
        "text-sm": true,
        "font-semibold": !this.highlightContent,
        "font-bold": this.highlightContent,
        ...this.generalTextStyles,
      };
    }

    get itemContent(): string | number{
      if (typeof this.content === "number") {
        return this.content;
      }

      return this.content || NO_INFORMATION;
    }

    get showExtra(): boolean {
      return this.itemExtraInfo !== undefined;
    }

    get containerClasses(): Record<string, boolean>{
      return {
        [this.customAlignment]: true,
        [this.containterLayoutClass]: true,
      }
    }

    get customAlignment(): string {
      return this.customAlign ? this.customAlign : "items-baseline";
    }

    get containterLayoutClass(): string {
      return this.isFoldable ? "mb-1 xs:flex xs:mb-0": "flex";
    }

    get labelClasses(): {[key: string]: boolean} {
      return {
        [this.width]: true,
        [this.labelClass]: true,
        ...this.generalTextStyles,
      }
    }
  }
